module.exports = __webpack_public_path__ + "img/pr-14.82c8f3c5.png";